"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var ValidationError = (function () {
    function ValidationError() {
    }
    return ValidationError;
}());
var ValidationMessagesComponent = (function () {
    function ValidationMessagesComponent() {
        this.messages = {};
        this.possibleErrors = [];
    }
    ValidationMessagesComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes['messages'] && this.messages) {
            this.possibleErrors = [];
            Object.keys(this.messages).forEach(function (k) {
                var possibleError = new ValidationError();
                possibleError.error = k;
                possibleError.message = _this.messages[k];
                _this.possibleErrors.push(possibleError);
            });
        }
    };
    return ValidationMessagesComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], ValidationMessagesComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.AbstractControl)
], ValidationMessagesComponent.prototype, "control", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ValidationMessagesComponent.prototype, "messages", void 0);
ValidationMessagesComponent = __decorate([
    core_1.Component({
        selector: 'validation-messages',
        template: "<div *ngIf=\"control && (submitted || control.touched) && !control.valid\">     <div *ngFor=\"let error of possibleErrors\">         <span *ngIf=\"control.errors && control.errors[error.error]\"               class=\"help-block haserrorfieldlevel\">{{error.message}}</span>     </div> </div>"
    }),
    __metadata("design:paramtypes", [])
], ValidationMessagesComponent);
exports.ValidationMessagesComponent = ValidationMessagesComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validation-messages/validation-messages.component.js